import whiteChair from '../assets/white-bg-chair-table.webp'
import desktopTable from '../assets/white-bg-desktop.webp'
import computerTable from '../assets/computer-table.webp'
import keyboard from '../assets/keyboard.webp'
import headphones from '../assets/headphones.webp'
import vintagePhone from '../assets/vintage-phone.webp'


const categories = [
    { 
        name:"headphones",
        subCategories: ["vintage", "gamer"],
        image: headphones
    }, 
    {
        name:"keyboards",
        subCategories: ["vintage", "office", "gamer"],
        image: keyboard
    }, 
    {
        name:"phones",
        subCategories: ["android", "Apple", "vintage"],
        image: vintagePhone
    }, 
    {
        name:"computers",
        subCategories: ["desktop", "laptop", "gaming", "tablet"],
        image: computerTable
    },
    {
        name:"tables",
        subCategories: ["standing", "office", "drawing"],
        image: desktopTable
    }, 
    {
        name:"chairs",
        subCategories: ["gaming", "vintage", "office", "rocking"],
        image: whiteChair
    }
]

export default categories